// extracted by mini-css-extract-plugin
export default {"Checkout":"Checkout_Checkout__tAlN9","open":"Checkout_open__9oLOW","View":"Checkout_View__DUkg0"};